function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
/* This is a 'physical' class that is mapped to
 * the team table. We can have methods on it that
 * we could call on retrieved database objects.
 */ export class Team {
    constructor(team){
        var _ref, _ref1;
        _define_property(this, "teamId", void 0);
        _define_property(this, "teamName", void 0);
        _define_property(this, "teamType", void 0);
        _define_property(this, "teamDescription", void 0);
        _define_property(this, "roleId", void 0);
        _define_property(this, "projectId", void 0);
        _define_property(this, "projectIds", void 0);
        _define_property(this, "accountLevelTeam", void 0);
        this.teamId = team.teamId;
        this.teamName = team.teamName;
        this.teamType = team.teamType;
        this.teamDescription = team.teamDescription;
        this.roleId = team.roleId;
        this.teamType = team.teamType;
        this.accountLevelTeam = (_ref = team === null || team === void 0 ? void 0 : team.accountLevelTeam) !== null && _ref !== void 0 ? _ref : false;
        this.projectIds = (_ref1 = team === null || team === void 0 ? void 0 : team.projectIds) !== null && _ref1 !== void 0 ? _ref1 : [];
    }
}
